import React, { memo } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';

import CardIcon from '@pedidosya/web-fenix/icons/CardIcon';

import messages from '../messages';

const Container = styled.div`
  width: 180px;
  padding: 6px;
  display: flex;
  align-items: center;
`;

const CreditCardIcon = styled(CardIcon)`
  padding-right: 16px;
`;

function OnlinePaymentAlert({ intl: { formatMessage } }) {
  return (
    <Container>
      <CreditCardIcon color="white" />
      {formatMessage(messages.shopOnlinePaymentAlert)}
    </Container>
  );
}

OnlinePaymentAlert.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(memo(OnlinePaymentAlert));
